import Component from 'antd/es/date-picker';
import 'antd/lib/date-picker/style';
export default Component;
